import { render, staticRenderFns } from "./pageLoader.vue?vue&type=template&id=c12687c0&scoped=true&"
import script from "./pageLoader.vue?vue&type=script&lang=js&"
export * from "./pageLoader.vue?vue&type=script&lang=js&"
import style0 from "./pageLoader.vue?vue&type=style&index=0&id=c12687c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12687c0",
  null
  
)

export default component.exports